<template>
  <div class="app-container">
    <div class="top">
      <div class="title">
        数据总览
        <el-date-picker v-model="value2" type="month" placeholder="选择月" @change="changeTime"> </el-date-picker>
      </div>
      <div class="data-box">
        <div class="name">数据看板</div>
        <div class="box">
          <div>
            <p>用户总数</p>
            <h3>{{ msg.total_count }}</h3>
            <div>
              <p>
                日 <i :class="[type[msg.today_total_arrow]]"></i><span>{{ msg.today_total_point }}</span>
              </p>
              <p>
                周 <i :class="[type[msg.w_total_arrow]]"></i><span>{{ msg.w_total_point }}</span>
              </p>
              <p>
                月 <i :class="[type[msg.m_total_arrow]]"></i><span>{{ msg.m_total_point }}</span>
              </p>
            </div>
          </div>
          <div>
            <p>新增用户</p>
            <h3>{{ msg.total_new }}</h3>
            <div>
              <p>
                日 <i :class="[type[msg.today_new_arrow]]"></i><span>{{ msg.today_new_point }}</span>
              </p>
              <p>
                周 <i :class="[type[msg.w_new_arrow]]"></i><span>{{ msg.w_new_point }}</span>
              </p>
              <p>
                月 <i :class="[type[msg.m_new_arrow]]"></i><span>{{ msg.m_new_point }}</span>
              </p>
            </div>
          </div>
          <div>
            <p>付费用户</p>
            <h3>{{ msg.total_pay }}</h3>
            <div>
              <p>
                日 <i :class="[type[msg.today_pay_arrow]]"></i><span>{{ msg.today_pay_point }}</span>
              </p>
              <p>
                周 <i :class="[type[msg.w_pay_arrow]]"></i><span>{{ msg.w_pay_point }}</span>
              </p>
              <p>
                月 <i :class="[type[msg.m_pay_arrow]]"></i><span>{{ msg.m_pay_point }}</span>
              </p>
            </div>
          </div>
          <div>
            <p>活跃用户</p>
            <h3>{{ msg.total_active }}</h3>
            <div>
              <p>
                日 <i :class="[type[msg.today_active_arrow]]"></i><span>{{ msg.today_active_point }}</span>
              </p>
              <p>
                周 <i :class="[type[msg.w_active_arrow]]"></i><span>{{ msg.w_active_point }}</span>
              </p>
              <p>
                月 <i :class="[type[msg.m_active_arrow]]"></i><span>{{ msg.m_active_point }}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <h3 class="title">用户行为数据</h3>
      <div class="search-bar flex">
        <div class="left">
          <el-select v-model="searchParam.t_type" clearable @clear="getLine">
            <el-option value="1" label="按天筛选"></el-option>
            <el-option value="2" label="按小时筛选"></el-option>
            <el-option value="3" label="按月筛选"></el-option>
            <el-option value="4" label="按年筛选"></el-option>
          </el-select>
          <el-date-picker
            v-model="value1"
            type="daterange"
            value-format="yyyy-MM-dd HH:mm:ss"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="changeTime2"
          >
          </el-date-picker>
          <!--    <el-select v-model="searchParam.source" clearable style="margin-left: 10px;" @clear="getLine">
                        <el-option value="1" label="全部来源"></el-option>

                    </el-select> -->
        </div>
        <div class="right">
          <el-button @click="getLine">查询</el-button>
          <el-button @click="userExport">下载表格</el-button>
        </div>
      </div>
      <div ref="chart" v-loading="loading2" class="chart"></div>
    </div>
  </div>
</template>

<script>
import { userList, userListLine, userExport } from "@/api/analysis.js";
import { mixin } from "@/mixins/pagination.js";
export default {
  mixins: [mixin],
  data() {
    return {
      value2: "",
      value1: "",
      type: { 1: "el-icon-top", 0: "", "-1": "el-icon-bottom" },
      searchParam: {
        keyword: "",
      },
      param1: {},
      loading2: false,
      msg: {},
      charts: null,
      tableData: [
        {
          id: 1,
          name: "课程",
          img: "",
          teacher: "授课老师",
          start_time: "2021-11-22",
          price: "12",
          old_price: "22",
          sale: 12,
          create_time: "2022-12-11",
        },
      ],
    };
  },
  mounted() {
    this.charts = this.$echarts.init(this.$refs.chart);
    this.getList();
    this.getLine();
  },
  methods: {
    userExport() {
      const param = {
        ...this.searchParam,
      };
      userExport(param);
    },
    changeTime2(val) {
      if (val) {
        this.searchParam = { ...this.searchParam, start_time: val[0], end_time: val[1] };
      } else {
        this.searchParam = { ...this.searchParam, start_time: "", end_time: "" };
        this.getLine();
      }
    },
    changeTime(val) {
      // console.log(val)
      if (val) {
        const st = val.format("yyyy-MM-dd hh:mm:ss");
        const end = new Date(val.getFullYear(), val.getMonth() + 1).format("yyyy-MM-dd hh:mm:ss");
        this.param1 = { start_time: st, end_time: end };
      } else {
        this.param1 = {};
      }
      this.getList();
    },
    createOption(res) {
      const option = {
        title: {
          text: "趋势图",
          left: "0",
          top: 0,
        },
        tooltip: {
          trigger: "axis",
        },
        legend: {
          data: ["用户总数", "新增用户", "付费用户", "活跃用户", "访客数量"],
          left: 0,
          bottom: 0,
        },
        grid: {
          left: 0,
          top: "10%",
          right: "5%",
          bottom: "10%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: res.time_arr,
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            name: "用户总数",
            data: res.total_arr,
            type: "line",
            lineStyle: {
              color: "rgba(255, 170, 0, 1.0)",
            },
            itemStyle: {
              color: "rgba(255, 255, 127, 1.0)",
            },

            smooth: true,
          },
          {
            name: "新增用户",
            data: res.new_arr,
            type: "line",
            lineStyle: {
              color: "rgba(232, 90, 19, 1.0)",
            },
            itemStyle: {
              color: "rgba(207, 97, 87, 1.0)",
            },

            smooth: true,
          },
          {
            name: "付费用户",
            data: res.pay_arr,
            type: "line",
            lineStyle: {
              color: "rgba(0, 255, 127, 1.0)",
            },
            itemStyle: {
              color: "rgba(0, 170, 0, 1.0)",
            },

            smooth: true,
          },
          {
            name: "活跃用户",
            data: res.active_arr,
            type: "line",
            lineStyle: {
              color: "rgba(17, 128, 232, 1)",
            },
            itemStyle: {
              color: "rgba(23, 164, 207, 1)",
            },

            smooth: true,
          },
          {
            name: "访客数量",
            data: res.no_arr,
            type: "line",
            lineStyle: {
              color: "rgba(167, 0, 167, 1.0)",
            },
            itemStyle: {
              color: "rgba(255, 0, 255, 1.0)",
            },

            smooth: true,
          },
        ],
      };
      return option;
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
    },
    toDetail(row) {
      console.log(row);
      this.$router.push({
        path: "/watch-live",
        query: row,
      });
    },
    toData(row) {
      this.$router.push({
        path: "/live-data",
        query: row,
      });
    },

    banItem() {
      this.$confirm("确定要删除该直播吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    async getLine() {
      const param = {
        ...this.searchParam,
      };
      console.log(param);
      this.loading2 = true;
      const res = await userListLine(param);
      this.loading2 = false;
      if (res && res.total_arr) {
        this.charts.setOption(this.createOption(res), true);
      }
    },
    async getList() {
      const param = {
        ...this.param1,
      };
      console.log(param);
      this.loading = true;
      const res = await userList(param);
      this.loading = false;
      if (res) {
        this.msg = res;
      }

      console.log(res);
    },
  },
};
</script>

<style lang="less" scoped="scoped">
.el-icon-bottom {
  color: red;
}
.el-icon-top {
  color: green;
}
.top {
  border-bottom: 1px solid #bbb;
  padding: 10px;

  .data-box {
    border: 1px solid #eee;
    margin: 20px 0;
    .name {
      background-color: #f5f5f5;
      line-height: 35px;
      padding: 10px;
    }
    .box {
      display: flex;
      text-align: center;
      padding: 20px;
      p {
        display: flex;
        align-items: center;
        justify-content: center;
        i {
          width: 15%;
          text-align: right;
          font-weight: 900;
        }
        span {
          // flex: 1;
          width: 20%;
        }
      }
      h3 {
        line-height: 65px;
        font-size: 40px;
      }
      & > div {
        width: 25%;
        border-right: 1px solid #f5f5f5;
        &:last-child {
          border: none;
        }
      }
    }
  }
}

.title {
  line-height: 40px;
  margin-top: 20px;
}

.chart {
  height: 400px;
}
</style>
